import { differenceInDays, differenceInHours, differenceInMinutes } from 'date-fns';

export function formatNotificationTimeAgo(updatedAt: number, now: number = Date.now()): string {
  const from = new Date(updatedAt);
  const to = new Date(now);

  const minutes = Math.max(0, differenceInMinutes(to, from));
  if (minutes < 60) {
    return `${Math.max(1, minutes)}m`;
  }

  const hours = differenceInHours(to, from);
  if (hours < 24) {
    return `${Math.max(1, hours)}h`;
  }

  return `${Math.max(1, differenceInDays(to, from))}d`;
}
